module.exports = __webpack_public_path__ + "files/11b666c7e831f24fba38d4828185f719.png";